// MachineUtilizationDashboard/components/OverallUtilizationCard.jsx

import Chart from "react-apexcharts";
import {
  formatNumber,
  getUtilizationLevel,
  safeNumber,
} from "../utils/machineDashboardUtils";

function OverallUtilizationCard({ data = {} }) {
  const utilization = safeNumber(data?.utilizationPercentage);
  const status = getUtilizationLevel(utilization);

  const chartOptions = {
    chart: {
      type: "radialBar",
      sparkline: {
        enabled: true,
      },
      animations: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },

    plotOptions: {
      radialBar: {
        startAngle: -120,
        endAngle: 120,

        hollow: {
          size: "68%",
        },

        track: {
          background: "#eaf0f8",
          strokeWidth: "100%",
        },

        dataLabels: {
          name: {
            show: true,
            offsetY: 28,
            fontSize: "12px",
            color: "#64748b",
          },

          value: {
            show: true,
            offsetY: -10,
            fontSize: "31px",
            fontWeight: 800,
            color: "#0f172a",

            formatter: (value) => `${formatNumber(value, 1)}%`,
          },
        },
      },
    },

    fill: {
      type: "gradient",

      gradient: {
        shade: "light",
        type: "horizontal",
        gradientToColors: ["#2f539d"],
        stops: [0, 100],
      },
    },

    stroke: {
      lineCap: "round",
    },

    labels: ["Overall utilization"],
  };

  return (
    <div className="mud-overall-card">
      <div className="mud-overall-card__chart">
        <Chart
          key={`overall-${utilization}`}
          options={chartOptions}
          series={[Math.min(utilization, 100)]}
          type="radialBar"
          height={270}
        />
      </div>

      <div className="mud-overall-card__details">
        <div className="mud-overall-card__headline">
          <div>
            <span>Factory performance</span>
            <h4>{formatNumber(utilization, 2)}%</h4>
          </div>

          <span
            className={`mud-performance-badge mud-performance-badge--${status.tone}`}
          >
            {status.label}
          </span>
        </div>

        <div className="mud-overall-stats">
          <div>
            <span>Average Machine Utilization</span>
            <strong>
              {formatNumber(data?.averageMachineUtilization, 2)}%
            </strong>
          </div>

          <div>
            <span>Machines Included</span>
            <strong>{formatNumber(data?.machinesIncluded)}</strong>
          </div>

          <div>
            <span>Overall Machine Actual Runtime</span>
            <strong>{data?.totalActualHours || "0s"} hours</strong>
          </div>

          <div>
            <span>Overall Machine Target Duration</span>
            <strong>{data?.totalTargetHours || "0s"} hours</strong>
          </div>
        </div>

        <div className="mud-runtime-progress">
          <div className="mud-runtime-progress__header">
            <span>Runtime progress against target</span>

            <strong>{formatNumber(utilization, 1)}%</strong>
          </div>

          <div className="mud-runtime-progress__track">
            <span
              style={{
                width: `${Math.min(Math.max(utilization, 0), 100)}%`,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default OverallUtilizationCard;